export const onboardUrls = {
    'login' : '/',
    'register' : '/auth/register',
    'forgotPassword': '/auth/forgot-password',
    'verifyEmail': '/auth/verify',
    'emailLinkSuccess': '/auth/email-verification-link/success',
    'passwordLinkSuccess': '/auth/password-reset-link/success',
    'profileCreationSuccess': '/profile-creation/success',
    'profileCreation': '/profile-creation',
    'passwordReset': '/auth/passsword-reset/:encryted_email/:random_number',
    'passwordResetSuccess': '/auth/passsword-reset/success',
    'accountActivation': '/auth/verify/:encryted_email/:random_number',
    'transactionHistory': '/certificates/:certificateNo/transaction-history',
}